module.exports = __webpack_public_path__ + "static/media/Topic_Icons2_TechnicalBox.0efd66d0.png";